module.exports = __webpack_public_path__ + "0607c812ed11f8a4c786b1119be08f7f.png";